import React, { useCallback, useEffect, useState } from 'react';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import {
    getAllLotteryBrandDay,
} from '../../../../redux/features/lotteryBrandDay/lotteryBrandDayService';
import TableSkeleton from '../../../../components/Skeleton';
import NoResultsFound from '../../../../components/NoResultsFound';
import Pagination from '../../../../components/Pagination';
import { viewLotteries } from '../../../../redux/features/lottery/lotteryService';
import Capricom from '../../../../assets/images/astro/1.png';
import Aquarius from '../../../../assets/images/astro/2.png';
import Pisces from '../../../../assets/images/astro/3.png';
import Aries from '../../../../assets/images/astro/4.png';
import Taurus from '../../../../assets/images/astro/5.png';
import Gemini from '../../../../assets/images/astro/6.png';
import Cancer from '../../../../assets/images/astro/7.png';
import Leo from '../../../../assets/images/astro/8.png';
import Virgo from '../../../../assets/images/astro/9.png';
import Libra from '../../../../assets/images/astro/10.png';
import Scorpio from '../../../../assets/images/astro/11.png';
import Sagittarius from '../../../../assets/images/astro/12.png';

const astroImages = {
    1: Capricom,
    2: Aquarius,
    3: Pisces,
    4: Aries,
    5: Taurus,
    6: Gemini,
    7: Cancer,
    8: Leo,
    9: Virgo,
    10: Libra,
    11: Scorpio,
    12: Sagittarius,
};

const ViewTickets = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const name = location.state?.name;
    const drawDate = location.state?.draw_date;
    const drawNo = location.state?.draw_no;
    const ticketCount = location.state?.count;

    const { isViewLoading, pageCount, ticketList } = useSelector((state) => state.lotteryTicket.viewTickets);

    const [skip, setSkip] = useState(1);
    const limit = 25;

    const fetchAllLotteries = useCallback(
        (filters = {}) => {
            const params = {
                draw_date: drawDate,
                draw_no: drawNo,
                lottery_brand_day_id: id,
                skip: skip,
                limit: limit,
                ...filters,
            };
            dispatch(viewLotteries(params));
        },
        [dispatch, drawDate, drawNo, id, skip]
    );

    useEffect(() => {
        fetchAllLotteries();
    }, [fetchAllLotteries]);

    useEffect(() => {
        dispatch(getAllLotteryBrandDay({ status: true }));
    }, [dispatch]);

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber);
    };

    return (
        <div className={`search-card`}>
            <div className={`search-card-header`}>
                <div className={`form-input-col`}>
                    <h1 className={`form-title ${styles.headDiv}`}>
                        {name}{' '}
                    </h1>
                    <p>Draw Date: {drawDate}</p>
                    <p>Draw Number: {drawNo}</p>
                    <p>Mega Prize: Rs. {ticketList[0]?.lottery.mega_prize.toLocaleString()}</p>
                    <p>Ticket Count: {ticketCount}</p>
                </div>
            </div>
            <div>
                {isViewLoading ? (
                    <TableSkeleton
                        columns={['Serial Number', 'Pattern']}
                        rowCount={10}
                        height={20}
                    />
                ) : ticketList.length > 0 ? (
                    <div className={`table-container`}>
                        <table className={`table`}>
                            <thead className={`thead`}>
                                <tr>
                                    <th className={`theadColumnOne`}>Serial Number</th>
                                    <th>Pattern</th>
                                </tr>
                            </thead>
                            <tbody className={`tbody`}>
                                {ticketList?.map((ticket) => (
                                    <tr key={ticket.id}>
                                        <td className={`tdataColumnOne`}>{ticket?.code}</td>
                                        <td>   <div className={styles.ticketDetails}>
                                            {ticket.lottery.lottery_brand_day.lottery_brand.code === 'MASAM' &&
                                                <div className={styles.masamNumberRow}>
                                                    <p className={styles.masamResultsLetter}>{ticket.masam.char}</p>
                                                    {ticket.masam.recd.split("").map((char, index) => (
                                                        <p key={index} className={styles.masamResultNumber}>{char}</p>
                                                    ))}
                                                </div>
                                            }
                                            {ticket.lottery.lottery_brand_day.lottery_brand.code === 'MEPO' &&
                                                <div className={styles.masamNumberRow}>
                                                    <p className={styles.masamResultsLetter}>{ticket.mepo.char}</p>
                                                    <p className={styles.masamResultSpNumber}>{ticket.mepo.sno.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{ticket.mepo.n1.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{ticket.mepo.n2.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{ticket.mepo.n3.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{ticket.mepo.n4.padStart(2, '0')}</p>
                                                </div>
                                            }
                                            {ticket.lottery.lottery_brand_day.lottery_brand.code === 'ADSA' &&
                                                <div className={styles.adsaNumberRow}>
                                                    <p className={styles.masamResultsLetter}>{ticket.adsa.char}</p>
                                                    <p className={`${styles.adsaResultNumberA} ${styles.masamResultNumber}`}>{ticket.adsa.arange.padStart(2, '0')}</p>
                                                    <p className={`${styles.adsaResultNumberB} ${styles.masamResultNumber}`}>{ticket.adsa.brange.padStart(3, '0')}</p>
                                                    <p className={`${styles.adsaResultNumberC} ${styles.masamResultNumber}`}>{ticket.adsa.crange.padStart(4, '0')}</p>
                                                </div>
                                            }
                                            {ticket.lottery.lottery_brand_day.lottery_brand.code === 'DHNI' &&
                                                <>
                                                    <div className={styles.adsaNumberRow}>
                                                        <p className={styles.dhniResultsLetter}>{ticket.dhni.char1}</p>
                                                        <p className={styles.dhniResultNumber}>{ticket.dhni.n1.padStart(2, '0')}</p>
                                                        <p className={styles.dhniResultNumber}>{ticket.dhni.n2.padStart(2, '0')}</p>
                                                        <p className={styles.dhniResultNumber}>{ticket.dhni.n3.padStart(2, '0')}</p>
                                                        <p className={styles.dhniResultNumber}>{ticket.dhni.n4.padStart(2, '0')}</p>
                                                    </div>
                                                    <div className={styles.adsaNumberRow}>
                                                        <p className={styles.dhniResultsLetter}>{ticket.dhni.char2}</p>
                                                        <p className={styles.dhniResultNumberSp}>{ticket.dhni.special.padStart(5, '0')}</p>
                                                    </div>
                                                </>
                                            }
                                            {ticket.lottery.lottery_brand_day.lottery_brand.code === 'GOVI' &&
                                                <div className={styles.masamNumberRow}>
                                                    <p className={styles.masamResultsLetter}>{ticket.govi.char1}</p>
                                                    <p className={styles.masamResultsLetter}>{ticket.govi.char2}</p>
                                                    <p className={styles.masamResultNumber}>{ticket.govi.n1.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{ticket.govi.n2.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{ticket.govi.n3.padStart(2, '0')}</p>
                                                    <p className={styles.masamResultNumber}>{ticket.govi.n4.padStart(2, '0')}</p>
                                                </div>
                                            }
                                            {ticket.lottery.lottery_brand_day.lottery_brand.code === 'HADA' &&
                                                <div className={styles.hadaCol}>
                                                    <div className={styles.hadaLeftCol}>
                                                        <img src={astroImages[ticket.hada.lagna]} alt={`Image ${ticket.hada.lagna}`} className={styles.hadaAstro} />
                                                    </div>
                                                    <div className={styles.hadaRighttCol}>
                                                        <div className={styles.adsaNumberRow}>
                                                            <p className={styles.dhniResultNumber}>{ticket.hada.n1.padStart(2, '0')}</p>
                                                            <p className={styles.dhniResultNumber}>{ticket.hada.n2.padStart(2, '0')}</p>
                                                            <p className={styles.dhniResultNumber}>{ticket.hada.n3.padStart(2, '0')}</p>
                                                            <p className={styles.dhniResultNumber}>{ticket.hada.n4.padStart(2, '0')}</p>
                                                        </div>
                                                        <div className={styles.hadaNumberRow}>
                                                            <p className={styles.hadaSpecial}>{ticket.hada.special}</p>
                                                            <p className={styles.hadaDaywaLetter}>{ticket.hada.dayn}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {ticket.lottery.lottery_brand_day.lottery_brand.code === 'JAYA' &&
                                                <div className={styles.jayaNumberRow}>
                                                    <p className={styles.masamResultsLetter}>{ticket.jaya.char}</p>
                                                    {ticket.jaya.recd.split("").map((char, index) => (
                                                        <p key={index} className={styles.masamResultNumber}>{char}</p>
                                                    ))}
                                                </div>
                                            }
                                        </div></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <NoResultsFound />
                )}
                <div className={`search-card-footer`}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ViewTickets;
